export enum JournalEntryScreen {
  addFiveMinuteEntry = "AddFiveMinuteEntry",
  addGratitudeEntry = "AddGratitudeEntry",
  addIAmGreatEntry = "AddIAmGreatEntry",
  addDiaryEntry = "AddDiaryEntry",
  addTagsEntry = "AddTagsEntry",
}
